import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { GeneralFormComponent } from 'src/app/components/controls/general-form/general-form.component';
import { ControlActions, TipoObjetoParaPermisos, ControllerMethods } from 'src/app/models/general.enum';
import { DataTableComponent } from 'src/app/components/controls/data-table/data-table.component';
import { ConfigWindow } from 'src/app/models/config-window';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-solicitud-pqrd',
  templateUrl: './solicitud-pqrd.component.html',
  styleUrls: ['./solicitud-pqrd.component.css']
})
export class SolicitudPqrdComponent extends GeneralFormComponent implements OnInit {

  PrimerNombre: any;
  SegundoNombre: any;
  PrimerApellido: any;
  SegundoApellido: any;


  public PostNgAfterViewInit() {
    this.PrimerNombre = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "PrimerNombre" });
    this.SegundoNombre = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "SegundoNombre" });
    this.PrimerApellido = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "PrimerApellido" });
    this.SegundoApellido = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "SegundoApellido" });
  }

  public AddComponentInstanceHandler(event) {
    debugger;
    if (event instanceof DataTableComponent) {
      debugger;
      if (event.name == 'GrillaReasignarUsuario' || event.name == 'GrillaAsignarExpediente') {
        event.parentContext = this;
      }
      this.componentsContainer.Tables.push(event);
    }
    else {
      super.AddComponentInstanceHandler(event)
    }
  }

  public OnActionEventHandler(event) {
    debugger;
    if (event.Name == "BtnContactos") {
      this.VerBuscar();
    }
    else
      super.OnActionEventHandler(event);
  }

  GetConfigPermisos() {
    let permissionsConfig: any = {
      TipoObjetoParaPermiso: TipoObjetoParaPermisos.Expediente,
      Pagina: this.Pagina, clear: true, CreatedRowConfig: {}
    };
  }

  VerBuscar() {
    debugger;

    let modeloTemp = {
      configPermisos: this.GetConfigPermisos(),
      config: this.Pagina.ConfigPage.HiddenControls[0],
      limpiarInternamente: true
    };

    let componentName = "DataTableComponent";
    let config: ConfigWindow = new ConfigWindow();
    config.classWindow = 'Info';
    config.titleWindow = "Busqueda de Contactos";
    config.returnInstance = true;
    config.modal = false;
    config.width = 750;
    config.height = 450;
    config.viewOk = false;
    config.cancel = 'Cerrar';
    config.closeable = true;
    config.resizable = true;
    config.draggable = true;

    this.utility.OpenWindow(componentName,
      config, modeloTemp).then(dataResult => {

        debugger;
        dataResult.componentInstance.parentContext = this;

        dataResult.componentInstance.postEditEmitter.subscribe(result => {
          debugger;
          this.SetDatosPorTipoContacto(dataResult.componentInstance.modelo.IdTipoContacto);
          this.modelo.modelo.IdContacto = dataResult.componentInstance.modelo.IdContacto;
          this.modelo.modelo.PrimerNombre = dataResult.componentInstance.modelo.PrimerNombre;
          this.modelo.modelo.SegundoNombre = dataResult.componentInstance.modelo.SegundoNombre;
          this.modelo.modelo.PrimerApellido = dataResult.componentInstance.modelo.PrimerApellido;
          this.modelo.modelo.SegundoApellido = dataResult.componentInstance.modelo.SegundoApellido;
          this.modelo.modelo.Celular = dataResult.componentInstance.modelo.Celular;
          this.modelo.modelo.Telefono = dataResult.componentInstance.modelo.Telefono;
          this.modelo.modelo.Ext = dataResult.componentInstance.modelo.Ext;
          this.modelo.modelo.Direccion = dataResult.componentInstance.modelo.Direccion;
          this.modelo.modelo.Correo = dataResult.componentInstance.modelo.Correo;
          this.modelo.modelo.IdCiudad = dataResult.componentInstance.modelo.IdCiudad;

          this.SetModelToControls();
          this.modelo.modelo['DataAdd']["OperacionSolicitud"] = "Reasignado";

        });
        dataResult.componentInstance.onActionEventEmitter.subscribe(result => {
          if (result.Action == 'ClearModel') {
            debugger;
            this.modelo.modelo.IdContacto = null;
            this.modelo.modelo.PrimerNombre = null;
            this.modelo.modelo.SegundoNombre = null;
            this.modelo.modelo.PrimerApellido = null;
            this.modelo.modelo.SegundoApellido = null;
            this.modelo.modelo.Celular = null;
            this.modelo.modelo.Telefono = null;
            this.modelo.modelo.Ext = null;
            this.modelo.modelo.Direccion = null;
            this.modelo.modelo.Correo = null;
            this.modelo.modelo.IdCiudad = null;

            this.modelo.modelo['DataAdd']["OperacionSolicitud"] = null;
            this.SetModelToControls();
          }
        });


        dataResult.componentInstance.loadedGridEmitter.subscribe(result => {


        });

        dataResult.onClosePromise.then(dataResultOnClose => {
          dataResult.componentInstance.ngOnDestroy();
          dataResult.componentInstance = null;
        });
      })
  }

  SetDatosPorTipoContacto(tipo) {
    debugger;
    if (this.PrimerNombre) {
      if (tipo == 7)// ciudaddano
      {

        this.PrimerNombre.Hidden = false;
        this.PrimerNombre.Label = "Primer Nombre";
        this.PrimerApellido.Hidden = false;
        this.SegundoApellido.Hidden = false;
        this.SegundoNombre.Hidden = false;
      }
      else if (tipo == 10)// Empresa
      {
        this.PrimerNombre.Label = "Razón Social";
        this.PrimerApellido.Hidden = true;
        this.SegundoApellido.Hidden = true;
        this.SegundoNombre.Hidden = true;
      }
    }
  }

  ConvertAnexos() {
    debugger;
    if (this.modelo.modeloVirtual.GrillaAnexos)
      this.modelo.modelo.Anexos = JSON.stringify(this.modelo.modeloVirtual.GrillaAnexos);
  }

  _Guardar(form: FormGroup, configButtons?: any) {
    debugger;
    this.ConvertAnexos();
    let obj: any = null;
    try {
      if (this.Pagina.Valida != true || this.Pagina.Guardar != true)
        return;
      if (form.invalid)
        return;


      let _isEdit = this.IsEdit;
      // const that = this;
      let processMessage = (this.modelo.modelo.PkValue == '0' || this.modelo.modelo.PkValue == '') ? 'Creando Registro de ' + this.Pagina.Titulo : 'Actualizando registro de ' + this.Pagina.Titulo;

      if (configButtons && configButtons.Actions) {

        this.helperActions.ExecuteActionsControl(configButtons,
          false, null, this.modelo, this.permissionsConfig,
          this, null, new EventEmitter<any>(), this.componentsContainer,
          null, this.modelo.modeloMetadata, { importUrl: this.importUrl });
      }

      this.ExcecuteFuntion(ControllerMethods.Save, false);


      if (_isEdit)
        this.FireFormEvent({ Name: "OnPreUpdate", modelo: this.modelo });
      else
        this.FireFormEvent({ Name: "OnPreInsert", modelo: this.modelo });

      if (this.modelo.modeloMetadata.Items.Count() > 0) {
        this.modelo.modeloMetadata.IdParentObject = this.modelo.modelo.PkValue;
        this.modelo.modeloMetadata.IdPage = this.Pagina.IdPagina;
        this.modelo.modelo.Metadata = this.utility.Clone(this.modelo.modeloMetadata);
        this.modelo.modelo.Metadata.Items = this.modelo.modelo.Metadata.Items.ToArray();
      }
      //this.modelo.modeloMetadata.Id = this.modelo.modelo.PkValue;
      // this.modelo.modeloMetadata.IdPage = this.Pagina.IdPagina;
      // this.modelo.modelo.Metadata = this.modelo.modeloMetadata;



      obj = this.utility.GetApiModel('Guardar', this.componentName, null, null, this.modelo.modelo);

      let isGeneralSave = true;

      if (this.componentsContainer.FileBox && this.componentsContainer.FileBox.isSelectedFiles()) {

        isGeneralSave = false;
        let externalFiles: any;
        if (this.componentsContainer.FileBoxWorkFlow != null) {
          externalFiles = this.componentsContainer.FileBoxWorkFlow.GetForExternalFilesModel();
        }
        this.componentsContainer.FileBox.uploadFiles(false, obj, externalFiles);

      }


      // ////////Meter validacion antes de este
      if (isGeneralSave) {
        this.baseService.InsertUpdate(obj, form, {
          componentName: this.componentName + 'Controller',
          method: 'Guardar', processMessage: processMessage
        },
          false, this.componentName, false, true).then(data => {
            //this.modelo.modelo = data.Data != null ? data.Data : this.modelo.modelo;

            this.FinGuardar(data.Data);

            if (_isEdit)
              this.FireFormEvent({ Name: "OnPostUpdate", modelo: this.modelo, data: data });
            else
              this.FireFormEvent({ Name: "OnPostInsert", modelo: this.modelo, data: data });


          }).catch(error => { this.SetProcesando(false); });
      }
    }
    catch (error) {
      this.utility.logger.LogError(error, obj, { componentName: this.componentName, method: '_Guardar' });
      this.utility.VerModalDanger().then(data => { })
      this.SetProcesando(false);
    }
  }

  public OnSelectedComboBox(item: any, controlName: string, config: any) {
    //debugger;
    /*if (controlName == 'IdTemaSolicitud' && item.Configuracion) {
      let configUsuarioResp = JSON.parse(item.Configuracion);
      this.modelo.modelo.IdUsuarioResponsable = configUsuarioResp[0].Id;
    }*/
    if(controlName == 'IdTemaSolicitud' && item.IdUsuarioResponsable){
      this.modelo.modelo.IdUsuarioResponsable = item.IdUsuarioResponsable;            
    }
    super.OnSelectedComboBox(item, controlName, config);
  }
}
